module.exports = __webpack_public_path__ + "static/img/mood5.fe8ab84.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/moods/mood5.png
// module id = JwOA
// module chunks = 1